/* eslint eqeqeq: 'off' */
import React, { Component } from 'react';
import { Row, Col, Button, FormGroup, Label,Table } from 'reactstrap';
import '../../../../../../Assets/EnsembleStyles/EnsCreateTenant.css';
import {FaQuestionCircle} from 'react-icons/fa';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { getAllResources } from '../../../../../../action/cultureAction';
import { SaveTenant } from '../../../../../../action/tenantAction';
import Currencies from '../../../../../../Resources/Currencies';
import DMResources from '../../../../../../Resources/DMResources.en-US';
import Conversions from '../../../../../../Resources/Conversions';

let Available_Zones = [];
let Available_Employees = [];
let Available_Meters = [];
let Available_FixedCharges = [];

var rowheight = {
    height: "20px"
}
var rowpadding = {
    "padding-left": "50px"
}
var rowpaddings = {
    "padding-left": "60px",
    "font-family":"Arial"
}
class Tenants_S extends Component {
    componentWillMount(){
        if(this.props.getLabels["ManageTenants.Create.Text"] === undefined){
            this.props.getAllResources();
        }
    }
    constructor(props) {
        super(props);
        this.state = {
            routeModules: {
            },
            redirect: false,
            redirectBack:false,
            SelectedZoneID: (this.props.ClientSideZonesState !== undefined && this.props.ClientSideZonesState !== null && this.props.ClientSideZonesState.length) ? this.props.ClientSideZonesState[0].zoneId : 0
        }
        this.FinishTenant = this.FinishTenant.bind(this);
        this.goBack = this.goBack.bind(this);
        this.SelectAssignedZone = this.SelectAssignedZone.bind(this);
    }

    goBack (){
        this.setState({redirectBack: true});
    }

    FinishTenant(){
        let lst_Zones = [];
        let Zones_Coll = [];
        lst_Zones = this.props.ClientSideZonesState;
        if(this.props.ClientSideAfterHourState != undefined && this.props.ClientSideAfterHourState.HasZoneRate){
            let lst_ZonesRates = this.props.ClientSideAfterHourState.ZoneRates;
            for(let i=0; i< lst_Zones.length; i++){
                for(let j=0; j<lst_ZonesRates.length; j++){
                    if(lst_Zones[i].zoneId == lst_ZonesRates[j].zoneId){
                        lst_Zones[i].zonRate = lst_ZonesRates[j].ZoneRate;
                    }
                }
                Zones_Coll.push({ZoneId:lst_Zones[i].zoneId,Rate:parseFloat(lst_Zones[i].zonRate)});
            }
        }else{
            if(lst_Zones != undefined){
            for(let i=0; i<lst_Zones.length; i++){
                Zones_Coll.push({ZoneId:lst_Zones[i].zoneId,Rate:0});
            }
            }
        }

        let lst_Meters = [];
        if(this.props.ClientSideMeterState != undefined){
            if(this.props.ClientSideMeterState.length){
                for(let i=0; i<this.props.ClientSideMeterState.length; i++){
                    let data = this.props.ClientSideMeterState[i];
                    lst_Meters.push({ObjectId:data.objectId,ObjectName:data.objectName,BuildingName:data.buildingName,
                        BuildingId:data.buildingId,ParentObjectId:data.parentObjectId,FamilyTypeId:data.familyTypeId,
                        Dimension:data.dimension,MeterType:0,Unit:data.unit,UnitText:data.unitText,
                        CustomName:data.customName,Rate:parseFloat(data.rate),Multiplier:parseFloat(data.multiplier)              
                    });
                }
            }
        }
        let lst_FixedCharges = [];
        if (this.props.ClientSideFixedChargesState != undefined && this.props.ClientSideFixedChargesState != null && this.props.ClientSideFixedChargesState.length) {
            for (let i = 0; i < this.props.ClientSideFixedChargesState.length; i++) {
                let data = this.props.ClientSideFixedChargesState[i];
                lst_FixedCharges.push({
                    FixedChargeName: data.fixedChargeName, FixedRate: parseFloat(data.fixedRate)
                });
            }
        }
        let Facility_Setup = {"SendToRequestedEmployee":true,"SendToAdditionalRecipient":false,"ToEmailAddress":[]};
        if (this.props.ClientSideNormalHourState == undefined || this.props.ClientSideNormalHourState === []) {
            var hours_of_operation_if_null = []
            for (var i = 0; i < 7; i++) {
                hours_of_operation_if_null.push({
                    "DayID": i,
                    "startTime": Conversions.ConvertValueto24hourTime(0),
                    "endTime": Conversions.ConvertValueto24hourTime(0),
                })
            }
        }

        var editData = {
            "TenantName": this.props.ClientSideComapnyState.TenantName,
            "Address": this.props.ClientSideComapnyState.Address,
            "ContactPhone": this.props.ClientSideComapnyState.ContactPhone,
            "InvoiceEmail": this.props.ClientSideComapnyState.InvoiceEmail,
            "CurrencyId" : this.props.ClientSideComapnyState.CurrencyId,
            "RatePerHour" : this.props.ClientSideAfterHourState != undefined ? this.props.ClientSideAfterHourState.RatePerHour : 50.00,
            "MinmumAfterHour": this.props.ClientSideAfterHourState != undefined ? this.props.ClientSideAfterHourState.MinmumAfterHour === "Select" ? null : this.props.ClientSideAfterHourState.MinmumAfterHour : null ,
            "RounderHours": this.props.ClientSideAfterHourState != undefined ? this.props.ClientSideAfterHourState.RounderHours === "Select" ? null : this.props.ClientSideAfterHourState.RounderHours : null,
            "HasZoneRate": this.props.ClientSideAfterHourState != undefined ? this.props.ClientSideAfterHourState.HasZoneRate : false,
            "Zones":Zones_Coll,
            "FacilitySetup": this.props.ClientSideAfterHourState != undefined ? this.props.ClientSideAfterHourState.FacilitySetup : Facility_Setup,
            "HasAfterHoursOption":this.props.ClientSideAfterHourState != undefined ? this.props.ClientSideAfterHourState.HasAfterHoursOption : false,
            "TenantUser": this.props.ClientSideEmployeeState != undefined ? this.props.ClientSideEmployeeState : [],
            "TenantConsumption": lst_Meters,
            "NormalHours": this.props.ClientSideNormalHourState != undefined ? this.props.ClientSideNormalHourState : hours_of_operation_if_null,
            "TenantFixedCharges": lst_FixedCharges
        };
        
        this.props.SaveTenant(editData);
        this.setState({redirect: true});

    }

    SelectAssignedZone(){
        var selectedOption = this.refs.AssignedZones_in_Select_input.options.selectedIndex;
        var selectedZoneID = this.refs.AssignedZones_in_Select_input.options[selectedOption].value;
        this.setState({SelectedZoneID: Number(selectedZoneID)});
    }

    render(ClientSideComapnyState, ClientSideAfterHourState, ClientSideZonesState, ClientSideEmployeeState, ClientSideMeterState, ClientSideNormalHourState, TenantId, ClientSideFixedChargesState, UserPreference_response, getLabels) {
        let CurrencySymb = null, AssignedZones = [];
        var l_sunday,l_monday,l_tuesday,l_wednesday,l_thursday,l_friday,l_saturday;
        l_sunday = l_monday = l_tuesday = l_wednesday = l_thursday = l_friday = l_saturday = "None";
        
        Available_Zones = [];Available_Employees = [];Available_Meters = [];Available_FixedCharges = [];
        
        let PreferedDateFormat = this.props.UserPreference_response;
        let label = this.props.getLabels;

        if(this.props.ClientSideComapnyState != undefined){
            CurrencySymb=  Currencies.CurrencySymbol(this.props.ClientSideComapnyState.CurrencyId);
        }
        let lTenantId = this.props.TenantId != null ? this.props.TenantId.tenantId : 0;
        if (this.state.redirect && lTenantId > 0) {
            return <Redirect to={"/managetenant"} />
        }
        if(this.state.redirectBack){
            if(this.props.ClientSideComapnyState != undefined){
                if(this.props.ClientSideComapnyState.HasFixedRate)
                    return <Redirect to={"/managetenant/TenantFixedCharges"} />
                else{
                    if(this.props.ClientSideComapnyState.HasMeter)
                        return <Redirect to={"/managetenant/TenantMeters"} />
                    else{
                        if(this.props.ClientSideComapnyState.HasAfterHrs)
                            return <Redirect to={"/managetenant/TenantEmployeeUsers"} />
                        else 
                            return <Redirect to={"/managetenant/CreateTenant"} />    
                    }
                }
            }
        }
        if(this.props.ClientSideAfterHourState != undefined){
            var Minimum_Hr = this.props.ClientSideAfterHourState.MinmumAfterHour === "Select"? "None": Conversions.formatNumberAHrs(PreferedDateFormat,this.props.ClientSideAfterHourState.MinmumAfterHour);
            var Rounded_Hr = this.props.ClientSideAfterHourState.RounderHours === "Select"? "None": Conversions.formatNumberAHrs(PreferedDateFormat,this.props.ClientSideAfterHourState.RounderHours);
        if(this.props.ClientSideAfterHourState.FacilitySetup.SendToAdditionalRecipient){
           var Email_List =  <div className="form_group ">
                    <Label className="Custom_label">{label['TenantFacility.AdditionalRecipients.Text'] !== undefined ? label['TenantFacility.AdditionalRecipients.Text'] : "Send notification for every request to:"}</Label> 
                    <Label className="Custom_label">{ (this.props.ClientSideAfterHourState.FacilitySetup.ToEmailAddress).join(',') }</Label>
            </div>            
        }
        var Zones_Rates = "";
        if(!this.props.ClientSideAfterHourState.HasZoneRate){
            var DefaultRate = <Label style={{"font-family":"Arial"}} className="Custom_label">{CurrencySymb} {Conversions.formatNumber(PreferedDateFormat,this.props.ClientSideAfterHourState.RatePerHour)}</Label>
        } else {
            if (this.props.ClientSideAfterHourState.ZoneRates != null) {
                Zones_Rates = this.props.ClientSideAfterHourState.ZoneRates.map(el => (
                    <tr style={rowheight}>
                        <td style={rowpadding}>{el.zoneName}</td>
                        <td style={rowpaddings}>{CurrencySymb}&nbsp;&nbsp;{Conversions.formatNumber(PreferedDateFormat, el.ZoneRate)}</td>
                    </tr>
                ))
            }
        }
        }
        
        if(this.props.ClientSideNormalHourState != undefined){
            if(this.props.ClientSideNormalHourState.length) {
                var data = this.props.ClientSideNormalHourState.filter(x => Number(x.zoneId) === Number(this.state.SelectedZoneID));
                
                if(data !== undefined && data !== null && data.length){
                for(var i=0; i < data.length; i++){
                    var l_starttime = new Date(data[i].startTime).toLocaleTimeString();
                    var l_endtime = new Date(data[i].endTime).toLocaleTimeString();
                    if(l_starttime != l_endtime){
                    switch(data[i].dayId){
                        case 0:
                        l_sunday = l_starttime + '-' + l_endtime;
                        break;
                        case 1:
                        l_monday = l_starttime + '-' + l_endtime;
                        break;
                        case 2:
                        l_tuesday = l_starttime + '-' + l_endtime;
                        break;
                        case 3:
                        l_wednesday = l_starttime + '-' + l_endtime;
                        break;
                        case 4:
                        l_thursday = l_starttime + '-' + l_endtime;
                        break;
                        case 5:
                        l_friday = l_starttime + '-' + l_endtime;
                        break;
                        case 6:
                        l_saturday = l_starttime + '-' + l_endtime;
                        break;
                        default:
                        break;
                    }
                }
                }
            }
        }
        }

        if (this.props.ClientSideZonesState != undefined && this.props.ClientSideZonesState !== null) {
            if (this.props.ClientSideZonesState.length) { 
                Available_Zones = this.props.ClientSideZonesState.map(el => (
                            <tr>
                                <td>{el.zoneName}</td>
                                <td>{el.buildingName}</td>
                                <td>{ el.members}</td>
                            </tr>
                ));
                AssignedZones = this.props.ClientSideZonesState.map(el =>(
                    <option value={el.zoneId} key={el.zoneId}>{el.zoneName}</option>
                ));
            }
        }
        if (this.props.ClientSideEmployeeState != undefined) {
            if (this.props.ClientSideEmployeeState.length) { 
                Available_Employees = this.props.ClientSideEmployeeState.map(el => (
                    <tr>
                        <td>{el.FirstName} {el.LastName}</td>
                        <td>{el.EmployeeEmail}</td>
                        <td>{el.ZoneName}</td>
                        {
                            el.ZonesTemperatureAdjustment.filter(x => x.AllowTemperatureAdjustment === true).length ?
                            <td>Allowed</td> : <td>Not Allowed</td>
                        }
                    </tr>
                ));
            }
        }
        if(this.props.ClientSideMeterState != undefined){
            if(this.props.ClientSideMeterState.length){
                Available_Meters = this.props.ClientSideMeterState.map(el => {
                    var l_value = "---";
                    if(el.datalogValue != null){
                        l_value = parseFloat(el.datalogValue).toFixed(2) + " "+ (el.unit != 0 && el.unit != 99999 ? DMResources.FamilyList('Enum3046.'+ el.unit +'.Text') : el.unitText);
                    }
                    return <tr>
                        <td>{el.customName}</td>
                        <td>{el.buildingName},{el.objectName}</td>
                        <td>{el.multiplier}</td>
                        <td style={{"font-family":"Arial"}}>{CurrencySymb} {" "}{Conversions.formatNumber(PreferedDateFormat,el.rate)}{' per '}{el.unit != 0 && el.unit != 99999 ? DMResources.FamilyList('Enum3046.'+ el.unit +'.Text') : el.unitText}</td>
                        <td>{l_value}</td>
                    </tr>
                });
            }
        }
        if(this.props.ClientSideFixedChargesState != undefined && this.props.ClientSideFixedChargesState != null && this.props.ClientSideFixedChargesState.length){
            Available_FixedCharges = this.props.ClientSideFixedChargesState.map(el => (
                <tr>
                    <td>{el.fixedChargeName}</td>
                    <td style={{"font-family":"Arial"}}>{CurrencySymb}&nbsp;&nbsp;{Conversions.formatNumber(PreferedDateFormat,el.fixedRate)}</td>
                </tr>
            ));
        }
        return (
            <div className="EnsembleCreateTenant">
                <Row>
                    <Col sm={{ size: 1, offset: 11 }} className="text-right" >
                        <FaQuestionCircle className="Ensemble_Icon Ensemble_question_Icon" />
                    </Col>
                </Row>
                <h5 className="form_sub_title">Create Tenant - Confirm Tenant Settings</h5>
                <div className="form_group ">
                </div>
                

                <div className="Customised_form_div_summary">

                    <legend className="form_sub_title">{label['CreateTenant.TenantInformation.Text'] !== undefined ? label['CreateTenant.TenantInformation.Text'] : "Tenant Company"}</legend>

                    <div className="form_group ">
                        <Label className="Custom_label">{label['CreateTenant.Name.Text'] !== undefined ? label['CreateTenant.Name.Text'] : "Company Name*"}</Label>
                        <Label className="Custom_label" style={{width:'50%'}}>{this.props.ClientSideComapnyState != undefined ? this.props.ClientSideComapnyState.TenantName:""}</Label>
                    </div>
                    <div className="form_group ">
                        <Label className="Custom_label">{label['CreateTenant.Address.Text'] !== undefined ? label['CreateTenant.Address.Text'] : "Billing Address"}</Label>
                        <Label className="Custom_label">{this.props.ClientSideComapnyState != undefined ? this.props.ClientSideComapnyState.Address : ""}</Label>
                    </div>
                    <div className="form_group ">
                        <Label className="Custom_label">{label['CreateTenant.InvoiceEmail.Text'] !== undefined ? label['CreateTenant.InvoiceEmail.Text'] : "Billing E-mail Address"}</Label>
                        <Label className="Custom_label">{this.props.ClientSideComapnyState != undefined ? this.props.ClientSideComapnyState.InvoiceEmail : ""}</Label>
                    </div>
                    <div className="form_group ">
                        <Label className="Custom_label">{label['CreateTenant.ContactInfo.Text'] !== undefined ? label['CreateTenant.ContactInfo.Text'] : "Contact Information"}</Label>
                        <Label className="Custom_label">{this.props.ClientSideComapnyState != undefined ? this.props.ClientSideComapnyState.ContactPhone : ""}</Label>
                    </div>
                    <legend className="form_sub_title">{label['CreateTenant.BillingOptions.Text'] !== undefined ? label['CreateTenant.BillingOptions.Text'] : "Billing Options"}</legend>

                    <div className="form_group ">
                        <Label className="Custom_label">{label['CreateTenant.lblBillingCurrency.Text'] !== undefined ? label['CreateTenant.lblBillingCurrency.Text'] : "Billing Currency"}</Label>
                        <Label className="Custom_label">{this.props.ClientSideComapnyState != undefined ? this.props.ClientSideComapnyState.Currency : ""}</Label>
                    </div>

                    <legend className="form_sub_title">After-Hour Billing Agreement </legend>

                    <div className="form_group ">
                        <Label className="Custom_label">{label['AfterHours.CostPerHour.Text'] !== undefined ? label['AfterHours.CostPerHour.Text'] : "Cost per Hour"}</Label>
                        {DefaultRate}
                    </div>
                    <div className="form_group">
                        {Zones_Rates}
                    </div>
                    <div className="form_group ">
                        <Label className="Custom_label">{label['CreateTenant.MinimumAfterHourschange.Text'] !== undefined ? label['CreateTenant.MinimumAfterHourschange.Text'] : "Minimum Request"}</Label>
                        <Label className="Custom_label">{Minimum_Hr === undefined ? "None" : Minimum_Hr}</Label>
                    </div>
                    <div className="form_group ">
                        <Label className="Custom_label">{label['CreateTenant.BilledItem.Text'] !== undefined ? label['CreateTenant.BilledItem.Text'] : "Round Up to Nearest"}</Label>
                        <Label className="Custom_label">{Rounded_Hr === undefined ? "None" : Rounded_Hr}</Label>
                    </div>
                    <legend className="form_sub_title">{label['AddEditSubGroups.PageHeader.FacilityRequest.Text'] !== undefined ? label['AddEditSubGroups.PageHeader.FacilityRequest.Text'] : "Facility Request Notifications"}</legend>

                    <div className="form_group ">
                        <Label className="Custom_label">{label['TenantFacility.EnableStatus.Text'] !== undefined ? label['TenantFacility.EnableStatus.Text'] : "E-mail notifications enabled"}</Label> &nbsp;&nbsp;&nbsp;&nbsp;
                        <Label className="Custom_label">{label['TenantFacility.SendEmail.Text'] !== undefined ? label['TenantFacility.SendEmail.Text'] : "Send confirmation to employee who creates or modifies a Facility Request"}</Label><br/>
                    </div>
                    <div className="form_group"></div>
                    {Email_List}
                    <div className="form_group"></div>
                    <Row>
                        <Col style={{ "max-width": "16%" }}>
                            <legend className="form_sub_title">{label['NormalHours.ViewModeHeading.Text'] !== undefined ? label['NormalHours.ViewModeHeading.Text'] : "Daily Normal Operating Hours"}</legend>
                        </Col>
                        <Col>
                            <span style={{ "font-size": "13px", "position": "relative", "top": "-10px", "color": "black" }}><b>Assigned Zones</b><br />
                                <select id='rdl_Assigned_zones' ref='AssignedZones_in_Select_input' onChange={this.SelectAssignedZone} className="InputFieldStyle" style={{ "height": "22px", "width": "150px" }}>
                                    {AssignedZones}
                                </select>
                            </span>
                        </Col>
                    </Row>
                    <div className="form_group ">
                        <Label className="Custom_label">{label['CreateTenant.Sunday.Text'] !== undefined ? label['CreateTenant.Sunday.Text'] : "Sunday"}</Label>
                        <Label className="Custom_label">{l_sunday}</Label>
                    </div>
                    <div className="form_group ">
                        <Label className="Custom_label">{label['CreateTenant.Monday.Text'] !== undefined ? label['CreateTenant.Monday.Text'] : "Monday"}</Label>
                        <Label className="Custom_label">{l_monday}</Label>
                    </div>
                    <div className="form_group ">
                        <Label className="Custom_label">{label['CreateTenant.Tuesday.Text'] !== undefined ? label['CreateTenant.Tuesday.Text'] : "Tuesday"}</Label>
                        <Label className="Custom_label">{l_tuesday}</Label>
                    </div>
                    <div className="form_group ">
                        <Label className="Custom_label">{label['CreateTenant.Wednesday.Text'] !== undefined ? label['CreateTenant.Wednesday.Text'] : "Wednesday"}</Label>
                        <Label className="Custom_label">{l_wednesday}</Label>
                    </div>
                    <div className="form_group ">
                        <Label className="Custom_label">{label['CreateTenant.Thursday.Text'] !== undefined ? label['CreateTenant.Thursday.Text'] : "Thursday"}</Label>
                        <Label className="Custom_label">{l_thursday}</Label>
                    </div>
                    <div className="form_group ">
                        <Label className="Custom_label">{label['CreateTenant.Friday.Text'] !== undefined ? label['CreateTenant.Friday.Text'] : "Friday"}</Label>
                        <Label className="Custom_label">{l_friday}</Label>
                    </div>
                    <div className="form_group ">
                        <Label className="Custom_label">{label['CreateTenant.Saturday.Text'] !== undefined ? label['CreateTenant.Saturday.Text'] : "Saturday"}</Label>
                        <Label className="Custom_label">{l_saturday}</Label>
                    </div>
                    

                    <legend className="form_sub_title">{label['SubGroups.Columns.Zones.Text'] !== undefined ? label['SubGroups.Columns.Zones.Text'] : "Zones"}</legend>
                    <div className="form_group ">
                    <Table striped responsive className="Custom_table">
                        <tbody>
                            <tr>
                                <th>{label['DefaultTemplate.Zone.Text'] !== undefined ? label['DefaultTemplate.Zone.Text'] : "Zone"}</th>
                                <th>{label['DefaultTemplate.Building.Text'] !== undefined ? label['DefaultTemplate.Building.Text'] : "Building"}</th>
                                <th>{label['TenantZones.Members.Text'] !== undefined ? label['TenantZones.Members.Text'] : "Members"}</th>                                
                            </tr>
                            {Available_Zones}
                        </tbody>
                    </Table>
                    </div>
                    <legend className="form_sub_title">Tenant Employees</legend>
                    <div className="form_group ">
                    <Table striped responsive className="Custom_table">
                        <tbody>
                            <tr>
                                <th>{label['AddEditTenantUser.TenantOccupantName.Text'] !== undefined ? label['AddEditTenantUser.TenantOccupantName.Text'] : "Employee"}</th>
                                <th>{label['AddEditTenantUser.TenantOccupantEmail.Text'] !== undefined ? label['AddEditTenantUser.TenantOccupantEmail.Text'] : "E-mail"}</th>
                                <th>{label['SubGroups.Columns.Zones.Text'] !== undefined ? label['SubGroups.Columns.Zones.Text'] : "Zones"}</th>
                                <th>{label['AddEditTenantUser.column.TemperatureSetting.Text'] !== undefined ? label['AddEditTenantUser.column.TemperatureSetting.Text'] : "Temperature Setting Adjustments"}</th>                               
                            </tr>
                            {Available_Employees}
                        </tbody>
                    </Table>
                    </div>
                    <legend className="form_sub_title">{label['TenantConsumption.UsageMeters.Text'] !== undefined ? label['TenantConsumption.UsageMeters.Text'] : "Usage Meters"}</legend>
                    <div className="form_group ">
                    <Table striped responsive className="Custom_table">
                        <tbody>
                            <tr>
                                <th>{label['FixedRateSetup.Name.Text'] !== undefined ? label['FixedRateSetup.Name.Text'] : "Name"}</th>
                                <th>{label['TenantConsumption.DataSource.Text'] !== undefined ? label['TenantConsumption.DataSource.Text'] : "Data Source"}</th>
                                <th>{label['TenantConsumption.Multiplier.Text'] !== undefined ? label['TenantConsumption.Multiplier.Text'] : "Multiplier"}</th>
                                <th>{label['TenantConsumption.Rate.Text'] !== undefined ? label['TenantConsumption.Rate.Text'] : "Rate"}</th>       
                                <th>{label['TenantConsumption.CurrentReading.Text'] !== undefined ? label['TenantConsumption.CurrentReading.Text'] : "Current Reading"}</th>                        
                            </tr>
                            {Available_Meters}
                        </tbody>
                    </Table>
                    </div>
                    <legend className="form_sub_title">{label['CreateTenant.FixedRateSetup.Text'] !== undefined ? label['CreateTenant.FixedRateSetup.Text'] : "Fixed Charges"}</legend>
                    <div className="form_group">
                    <Table striped responsive className="Custom_table">
                        <tbody>
                            <tr>
                                <th>{label['FixedRateSetup.Name.Text'] !== undefined ? label['FixedRateSetup.Name.Text'] : "Name"}</th>
                                <th>{label['TenantConsumption.Charges.Text'] !== undefined ? label['TenantConsumption.Charges.Text'] : "Charge"}</th>                      
                            </tr>
                            {Available_FixedCharges}
                        </tbody>
                    </Table>
                    </div>
                    
                    <FormGroup row className="btns_group">
                        <Col sm={{ size: 10 }}>
                            <Button id="createtenant_confirmation_back" className="btn-gray btn-md" onClick={this.goBack}> {"<"} Back </Button>
                            <Button id="createtenant_confirmation_finish" className="btn-success btn-md" onClick={() => this.FinishTenant()} >Finish</Button>
                        </Col>
                    </FormGroup>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        ClientSideComapnyState: state.manageTenant.ClientSideComapnyData,
        ClientSideAfterHourState: state.manageTenant.ClientSideAfterHoursData,
        ClientSideZonesState: state.manageTenant.ClientSideZonesData,
        TenantId: state.tenantsRootReducer.TenantId,
        ClientSideEmployeeState: state.manageTenant.ClientSideEmployeesData,
        ClientSideMeterState: state.manageTenant.ClientSideMeterData,
        ClientSideNormalHourState: state.manageTenant.ClientSideNormalHoursData,
        ClientSideFixedChargesState: state.manageTenant.ClientSideFixedChargesData,
        UserPreference_response: state.userPreferencesRootReducer.UserPreference,
        getLabels: state.CulturalLabelsRootReducer.LabelsBasedOnPreference
    };
};

const mapDispatchToProps = dispatch => {
    return {
        SaveTenant: (TenantData) => dispatch(SaveTenant(TenantData)),
        getAllResources: () => dispatch(getAllResources())      
    };
};

export default connect(mapStateToProps, mapDispatchToProps,null,{
    pure:false
})(Tenants_S)

